import {
  Autocomplete,
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { findAndReplace } from '../../../api/invoicing';
import { getFacilityManagers, getInvoices } from '../../../redux/slices/invoicing';
import { useDispatch, useSelector } from '../../../redux/store';
import { ConfirmDialog } from '../../../reusable-components/confirm-dialog';
import CloseIconButton from '../../../reusable-components/basic-buttons/CloseIconButton';

export default function FindAndReplace({ open, onClose}) {
  const dispatch = useDispatch();
  const {
    data: { pendingInvoicing, facilityManagers },
  } = useSelector((state) => state.invoicing);

  const managerOptions = useMemo(
    () => facilityManagers?.map((m) => ({ id: m.id, label: `${m?.name} - ${m?.email}` })),
    [facilityManagers]
  );
  const invoiceIds = useMemo(() => pendingInvoicing.map((i) => i.id), [pendingInvoicing]);

  const [value, setValue] = useState({
    replaceType: 'Manager',
    find: '',
    replaceWith: '',
  });

  useEffect(() => {
    if (open) dispatch(getFacilityManagers());
  }, [dispatch, open]);

  useEffect(() => {
    setValue((prev) => ({
      ...prev,
      find: '',
      replaceWith: ''
    }));
  }, [open]);

  const handleCloseDialog = () => {
    setValue({
      replaceType: 'Manager',
      find: '',
      replaceWith: '',
    });
    if (onClose) onClose();
  };

  const sendChangeManagerRequest = async () => {
    await findAndReplace(value, invoiceIds);
    await dispatch(getInvoices(false));
    handleCloseDialog();
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
        handleCloseDialog();
      }}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle sx={{ textAlign: 'flex-start' }}>
        <CloseIconButton onClick={handleCloseDialog}/>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ width: '90%', m: 2, mb: 0 }}>
          <Typography>Find</Typography>
          <Autocomplete
            options={managerOptions}
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            renderInput={(params) => <TextField {...params} autoComplete="off"/>}
            value={value.find}
            onChange={(event, val) => setValue({ ...value, find: val })}
          />
        </Box>
        <Box sx={{ width: '90%', m: 2 }}>
          <Typography>Replace with</Typography>
          <Autocomplete
            options={managerOptions}
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            renderInput={(params) => <TextField {...params} autoComplete="off"/>}
            value={value.replaceWith}
            onChange={(event, val) => setValue({ ...value, replaceWith: val })}
          />
        </Box>
        <Box sx={{ width: '90%', m: 2 }}>
          <Grid container justifyContent="flex-end" sx={{ mt: 3 }}>
            <ConfirmDialog
              icon=""
              title={`Replace ${value?.replaceType}`}
              color="primary"
              variant="contained"
              button="filled"
              size="medium"
              content={`Are you sure you want to replace all?`}
              actionButton={`Replace ${value?.replaceType}`}
              action={sendChangeManagerRequest}
            />
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
